module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Bold.88468edc.woff2";